/**
 * @generated SignedSource<<8b19240a96b1ae96a719c1b0ab1e83a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type TimeSlotBookingDetailsStepNode$data = {
  readonly agenda: {
    readonly facility: {
      readonly club: {
        readonly supportsPrivate: boolean;
      } | null | undefined;
    };
    readonly id: string;
  };
  readonly course: {
    readonly courseBucket: {
      readonly id: string;
    } | null | undefined;
  };
  readonly id: string;
  readonly time: string;
  readonly type: SlotType;
  readonly " $fragmentSpreads": FragmentRefs<"CourseLayoutControlNode" | "GroupSizeControlNode" | "TransportationTypeControlNode">;
  readonly " $fragmentType": "TimeSlotBookingDetailsStepNode";
};
export type TimeSlotBookingDetailsStepNode$key = {
  readonly " $data"?: TimeSlotBookingDetailsStepNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSlotBookingDetailsStepNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSlotBookingDetailsStepNode",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseBucket",
          "kind": "LinkedField",
          "name": "courseBucket",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPrivate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupSizeControlNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseLayoutControlNode"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "memberId",
          "variableName": "memberId"
        },
        {
          "kind": "Variable",
          "name": "membershipTypeId",
          "variableName": "membershipTypeId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TransportationTypeControlNode"
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};
})();

(node as any).hash = "fa2706f530a251ddf12f581c41aea640";

export default node;
